import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Translate } from 'react-localize-redux';
import itemsStyles from '../SurveyPartItems/surveyPartItems.module.css';
import {
  relativeCategoryTypeValues,
  SurveySchemaPartEditorType
} from '../../../../constants/types';
import { addVariableAction } from '../../../../actions';
import Variable from '../Variable';
import { getMessages } from '../../../../i18n';

const defaultEmptyVariable = {
  name: {},
  description: {},
  summaryDescription: {},
  questions: [],
  responseCategories: relativeCategoryTypeValues.map((type) => ({
    relativeCategory: {
      type
    },
    feedback: getMessages('defaultRelativeFeedback'),
    improvementSuggestions: {}
  }))
};

class Variables extends Component {
  constructor(props) {
    super(props);

    this.nextFreeVariableCode = this.nextFreeVariableCode.bind(this);
    this.onClickAddVariable = this.onClickAddVariable.bind(this);

    const defaultOpenVariableIndex = () => {
      const { variables } = this.props.surveySchemaPart;
      if (variables) {
        return Math.max(variables.length - 1, 0);
      }
      return 0;
    };

    this.state = {
      openVariableIndex: defaultOpenVariableIndex()
    };
  }

  onClickAddVariable() {
    this.setState({
      openVariableIndex: this.props.surveySchemaPart.variables.length
    });
    this.props.dispatchAddVariable({
      code: this.nextFreeVariableCode(), order: this.nextOrderNumber(), ...defaultEmptyVariable
    });
  }

  onToggleOpenVariable(index) {
    return (open) => {
      this.setState({
        openVariableIndex: (open) ? index : -1
      });
    };
  }

  nextFreeVariableCode() {
    const getIndex = (code) => Number(code.match(/\d*$/)[0]) || 0;
    const maxIndex = (curr, code) => Math.max(curr, getIndex(code));
    const lastIndex = this.props.surveySchemaPart.variables
      .reduce((max, variable) => maxIndex(max, variable.code), 0);

    return `${this.props.surveySchemaPart.code}_dim_${lastIndex + 1}`;
  }

  nextOrderNumber() {
    const { variables } = this.props.surveySchemaPart;
    return variables.reduce((order, variable) => Math.max(order, variable.order), 0) + 1;
  }

  render() {
    const variables = this.props.surveySchemaPart.variables || [];
    return (
      <div className={itemsStyles.elementsContainer}>
        <ul>
          {variables.map((variable, index) => (
            <Variable
              key={variable.code}
              index={index}
              isOpen={this.state.openVariableIndex === index}
              toggleOpen={this.onToggleOpenVariable(index)}
              lockedFromEditing={this.props.lockedFromEditing}
            />
          ))}
        </ul>
        {!this.props.lockedFromEditing
          && (
          <div className={`${itemsStyles.header} ${itemsStyles.addElementHeader}`}>
            <button type="button" onClick={this.onClickAddVariable} data-cy="survey-schema-part-add-variable-button">
              <Translate id="surveySchemaParts.dimensions.add" /> +
            </button>
          </div>
          )}
      </div>
    );
  }
}

const { func, bool } = PropTypes;
Variables.propTypes = {
  surveySchemaPart: SurveySchemaPartEditorType.isRequired,
  dispatchAddVariable: func.isRequired,
  lockedFromEditing: bool.isRequired
};

const mapStateToProps = ({ surveySchemaPart }) => ({
  surveySchemaPart: surveySchemaPart.surveySchemaPartOptions
});

const mapDispatchToProps = (dispatch) => ({
  dispatchAddVariable: (variable) =>
    dispatch(addVariableAction(variable))
});

export default connect(mapStateToProps, mapDispatchToProps)(Variables);
